"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUEST_CATALOG_META_FAIL = exports.REQUEST_CATALOG_META_SUCCESS = exports.REQUEST_CATALOG_META = void 0;
exports.REQUEST_CATALOG_META = 'REQUEST_CATALOG_META';
exports.REQUEST_CATALOG_META_SUCCESS = 'REQUEST_CATALOG_META_SUCCESS';
exports.REQUEST_CATALOG_META_FAIL = 'REQUEST_CATALOG_META_FAIL';
